export const loginUser = (apiInstance, user, password) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(
    `${apiInstance.apiURL}/Security/GetLogin/${user}/${password}`,
    requestParameters
  )
}

export const getUserData = (apiInstance, clientDocNumber) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(
    `${apiInstance.apiURL}/Security/GetUserData?userDocNumber=${clientDocNumber}`,
    requestParameters
  )
}

export const registerUser = (apiInstance, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(`${apiInstance.apiURL}/Security/CreateUser`, requestParameters)
}

export const getUserAddresses = (apiInstance, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Security/GetUserAddresses`,
    requestParameters
  )
}

export const getUserAddressById = (apiInstance, userId, addressId) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(
    `${apiInstance.apiURL}/Security/GetNewUserAddressById?userId=${userId}&addressId=${addressId}`,
    requestParameters
  )
}

export const updateUserAddress = (apiInstance, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Security/UpdateUserAddress`,
    requestParameters
  )
}

export const updateUserAddressById = (apiInstance, data, addressId) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }
  console.log('updateUserAddressById -> requestParameters:', requestParameters)

  return fetch(
    `${apiInstance.apiURL}/Security/EditNewUserAddress?addressId=${addressId}`,
    requestParameters
  )
}

export const updateUserTransport = (apiInstance, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Security/UpdateUserTransport`,
    requestParameters
  )
}

export const addNewUserAddress = (apiInstance, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Security/AddNewUserAddress`,
    requestParameters
  )
}

export const deleteNewUserAddress = (apiInstance, userId, addressId) => {
  let requestParameters = {
    method: 'DELETE',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(
    `${apiInstance.apiURL}/Security/DeleteNewUserAddress?userId=${userId}&addressId=${addressId}`,
    requestParameters
  )
}

export const resetPassword = (apiInstance, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Security/ResetPassword`,
    requestParameters
  )
}

export const changePassword = (
  apiInstance,
  currentPassword,
  newPassword,
  userId,
  userEmail
) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify({
      currentPassword: `${currentPassword}`,
      newPassword: `${newPassword}`,
      userId: `${userId}`,
      userEmail: `${userEmail}`
    })
  }

  return fetch(
    `${apiInstance.apiURL}/Security/ChangePassword`,
    requestParameters
  )
}
